import { render, staticRenderFns } from "./HistoricoBaixaManual.vue?vue&type=template&id=034124fc&scoped=true"
import script from "./HistoricoBaixaManual.vue?vue&type=script&lang=js"
export * from "./HistoricoBaixaManual.vue?vue&type=script&lang=js"
import style0 from "./HistoricoBaixaManual.vue?vue&type=style&index=0&id=034124fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034124fc",
  null
  
)

export default component.exports